// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/$location._c.users_.$user/route.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/$location._c.users_.$user/route.tsx");
}
// REMIX HMR END

import { userListExample } from '@commural/shared-resources/schemas/business/User.example';
import { useLoaderDataWithCache } from '@commural/shared-resources/utils/common';
import { Link } from '@remix-run/react';
import invariant from 'tiny-invariant';
import { z } from 'zod';
import { ScrollView } from '~/components/ScrollView';
import { getCapitalized } from '~/utils.server';
import cn from './User.module.css';
const TITLE = 'user history';
const Tabs = ['login', 'post', 'event', 'coupon', 'questionnaire'];
const TabsEnum = z.enum(Tabs);
_c = TabsEnum;
export async function loader({
  request,
  context,
  params
}) {
  const title = await getCapitalized(TITLE, request, context);
  const url = new URL(request.url);
  const result = TabsEnum.safeParse(url.searchParams.get('tab') ?? 'login');
  const tab = result.success ? result.data : 'login';
  const user = userListExample.find(el => el.id === params.user);
  return {
    title,
    tab,
    user
  };
}
export const meta = ({
  data
}) => {
  invariant(data?.title, 'title is required');
  return [{
    title: data.title
  }];
};
export const handle = {
  leaf: true,
  title: TITLE
};
export default function Index() {
  _s();
  const {
    tab,
    user
  } = useLoaderDataWithCache();
  if (user === undefined) {
    return <div>user not found</div>;
  }

  //TODO: アバターがない場合の処理
  const avatarURL = user.avatarURL ?? 'http://placekitten.com/200/200/';
  return <ScrollView>
      <section className={cn.User}>
        <header className={cn.Header}>
          <button className="debug-block">change roll</button>
          <button className="debug-block">remove account</button>
        </header>
        <main>
          <nav className={cn.Tabs}>
            <ul>
              {Tabs.map(tab => <li key={tab}>
                  <Link to={`?tab=${tab}`} replace>
                    {tab}
                  </Link>
                </li>)}
            </ul>
          </nav>
          <div className={cn.Content}>{renderTab(tab)}</div>
          <div>
            <img className={cn.Avatar} src={avatarURL} alt={user.name} />
            <div className={cn.Name}>{user.name}</div>
            <div>role</div>
            <div>{user.role}</div>
          </div>
        </main>
      </section>
    </ScrollView>;
}
_s(Index, "i5MSdQumEJP/kj8PBhQ7t80TG1Y=", false, function () {
  return [useLoaderDataWithCache];
});
_c2 = Index;
function renderTab(tab) {
  switch (tab) {
    case 'login':
      return <LoginTab />;
    case 'post':
      return <PostTab />;
    case 'event':
      return <EventTab />;
    case 'coupon':
      return <CouponTab />;
    case 'questionnaire':
      return <QuestionnaireTab />;
  }
}
function LoginTab() {
  return <div>Login Tab</div>;
}
_c3 = LoginTab;
function PostTab() {
  return <div>Post Tab</div>;
}
_c4 = PostTab;
function EventTab() {
  return <div>Event Tab</div>;
}
_c5 = EventTab;
function CouponTab() {
  return <div>Coupon Tab</div>;
}
_c6 = CouponTab;
function QuestionnaireTab() {
  return <div>Questionnaire Tab</div>;
}
_c7 = QuestionnaireTab;
var _c, _c2, _c3, _c4, _c5, _c6, _c7;
$RefreshReg$(_c, "TabsEnum");
$RefreshReg$(_c2, "Index");
$RefreshReg$(_c3, "LoginTab");
$RefreshReg$(_c4, "PostTab");
$RefreshReg$(_c5, "EventTab");
$RefreshReg$(_c6, "CouponTab");
$RefreshReg$(_c7, "QuestionnaireTab");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;